import { get, post } from "../utility/fetch-util";

/**
 * Get the begin guidance notes
 */
export const getDriverIncidentBeginNotes = async (contractId, progress) => {
    return get('/api/drivers/incident/co-group/begin-notes/' + contractId, null, progress);
}

/**
 * Get the General config as related to the vehicle and date
 */
export const getDriverIncidentConfig = async (vehicleId, date, progress) => {
    return get('/api/drivers/incident/config/' + vehicleId + '/' + date, null, progress);
}

/**
 * Get the possible types of the Incident
 */
export const getIncidentTypes = async (progress) => {
    return get('/api/drivers/incident/types/', null, progress);
}


/**
 * Get the possible causes of the Incident
 */
export const getIncidentCauses = async (typeId, progress) => {
    return get('/api/drivers/incident/types/' + typeId + '/causes/', null, progress);
}


/**
 * Get the possible classifications of the Incident
 */
export const getIncidentClasses = async (typeId, causeId, progress) => {
    return get('/api/drivers/incident/types/' + typeId + '/causes/' + causeId + '/classes/', null, progress);
}

/**
 * Get the incident questions for the cause
 */
export const getIncidentQuestions = async (typeId, causeId, progress) => {
    return get('/api/drivers/incident/types/' + typeId + '/causes/' + causeId + '/questions/', null, progress);
}

/**
 * Get the incident questions for the cause
 */
export const getIncidentRepairMandatory = async (typeId, causeId, progress) => {
    return get('/api/drivers/incident/types/' + typeId + '/causes/' + causeId + '/repair-mandatory', null, progress);
}

/**
 * Get the maximum number of files that can be uploaded for an incident
 */
export const getMaxUploads = async (progress) => {
    return get('/api/drivers/incident/config/uploads', null, progress);
}

/**
 * Update the driver for the signed in user
 */
export const saveDriver = async (driver, progress) => {
    return post('/api/drivers/driver', null, driver, progress);
}

export const getWeatherConditions = async (progress) => {
    return get('/api/drivers/incident/weather', null, progress);
}

export const getJourneyTypes = async (progress) => {
    return get('/api/drivers/incident/journey', null, progress);
}

export const getLiabilityStatuses = async (progress) => {
    return get('/api/drivers/incident/liability-statuses', null, progress);
}


export const getValidImMediaTypes = async (progress) => {
    return get('/api/drivers/incident/media-types', null, progress);
}

export const getInvestigationOutcomes = async (progress) => {
    return get('/api/drivers/incident/police-outcomes', null, progress);
}

export const getInvestigationStatuses = async (progress) => {
    return get('/api/drivers/incident/police-statuses', null, progress);
}

export const getWitnessTypes = async (progress) => {
    return get('/api/drivers/incident/witness-types', null, progress);
}

export const getThirdPartyTypes = async (progress) => {
    return get('/api/drivers/incident/third-party-types', null, progress);
}

export const getInjurySeverityTypes = async (progress) => {
    return get('/api/drivers/incident/injury-severity-types', null, progress);
}

export const getInjuredPartyTypes = async (hasThirdParties, progress) => {
    return get('/api/drivers/incident/injured-party-types', {hasThirdParties:hasThirdParties}, progress);
}

export const getRecoveryLocations = async (progress) => {
    return get('/api/drivers/incident/recovery-locations', null, progress);
}

export const submitIncident = async (incident, progress) => {
    return post('/api/drivers/incident/submit', null, incident, progress);
}

export const getIncidentConfirmGuidance = async (incidentId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/end-notes', null, progress);
}

export const getIncidentReference = async (incidentId, driverId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/reference', {driverId: driverId}, progress);
}

export const getIncidentSummaries = async (vehicleId, includeClosed, progress) => {
    return get('/api/drivers/incident/' + vehicleId + '/all', {openOnly : includeClosed ? "N" : "Y"}, progress);
}

export const getIncidentDetail = async (incidentId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/details', null, progress);
}

export const getIncidentDamages = async (incidentId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/damage', null, progress);
}

export const getIncidentReplacementVehicle = async (incidentId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/replacement-vehicle', null, progress);
}

export const getIncidentFiles = async (incidentId, progress) => {
    return get('/api/drivers/incident/' + incidentId + '/files', null, progress);
}

export const addIncidentFiles = async (incidentId, files, progress) => {
    return post('/api/drivers/incident/' + incidentId + '/upload', null, files, progress);
}